import {
  Dialog,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@sr/ui-library';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MEMBERSHIP_AGREEMENT_URL } from '../../constant/Common';
import { userService } from '../../reducers/permissions/userSlice';
import { useTypedSelector } from '../../stateStore';
import {
  getCurrentUserFullName,
  userInitials,
} from '../../utils/helpers/common';
import { AppDropdownButton } from '../AppDropdownButton';
import { PrefetchingLink } from '../PrefetchingLink';
import { NotificationsNavGate } from './NotificationsNavGate';

export const UserProfileDropdown = () => {
  const navigate = useNavigate();
  const [isLogOutModalOpen, setIsLogOutModalOpen] = useState(false);

  const currentUser = useTypedSelector(userService.selectors.userMe);
  const userFullName = getCurrentUserFullName(currentUser);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <AppDropdownButton className="w-full" overrideClass={false}>
            <AppDropdownButton.Avatar>
              {userInitials(userFullName)}
            </AppDropdownButton.Avatar>

            <AppDropdownButton.Text>{userFullName}</AppDropdownButton.Text>
          </AppDropdownButton>
        </DropdownMenuTrigger>

        <DropdownMenuContent align="end">
          <DropdownMenuItem asChild>
            <PrefetchingLink to="/profile/my-profile">
              My Profile
            </PrefetchingLink>
          </DropdownMenuItem>

          <NotificationsNavGate>
            <DropdownMenuItem asChild>
              <PrefetchingLink to="/profile/notifications">
                Notifications
              </PrefetchingLink>
            </DropdownMenuItem>
          </NotificationsNavGate>

          <DropdownMenuSeparator />

          <DropdownMenuItem asChild>
            <Link
              rel="noopener noreferrer"
              target="_blank"
              to="https://knowledge.screenrights.org/en"
            >
              Help
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link rel="noopener noreferrer" target="_blank" to="/terms">
              Terms and Conditions
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link
              rel="noopener noreferrer"
              target="_blank"
              to={MEMBERSHIP_AGREEMENT_URL}
            >
              Membership Agreement
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="font-medium"
            onClick={() => setIsLogOutModalOpen(true)}
          >
            Log out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <Dialog
        heading="Are you sure you want to log out?"
        actionButtonProps={{
          children: 'Log out',
          onClick: () => navigate('/logout'),
        }}
        open={isLogOutModalOpen}
        onOpenChange={setIsLogOutModalOpen}
      />
    </>
  );
};
